import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "grid-visibility"
  static values = { gridPath: String }

  connect() {
    this.debounceTimer = null;
    this.wasHidden = false;
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.wasHidden = document.hidden;
  }

  disconnect() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  handleVisibilityChange() {
    const isVisible = !document.hidden;
    
    if (isVisible && this.wasHidden) {
      // Debounce: Wait 1 second to handle rapid switches
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.reloadGridPanel();
      }, 1000);
    }
    
    this.wasHidden = document.hidden;
  }

  reloadGridPanel() {
    const gridFrame = document.getElementById('grid-panel');
    if (!gridFrame || !this.gridPathValue) return;

    gridFrame.src = '';  // Reset to force reload
    gridFrame.src = this.gridPathValue;
    gridFrame.dataset.state = 'loading';  // Optional: Trigger loading state visually
  }
}